import { GLOWApiClient } from '../apiClients/GLOWClient';
import {
  buildProfessionalClientSummaryRequest,
} from './clientSummaryRequest';

export const clientSummaryApi = GLOWApiClient.injectEndpoints({
  endpoints: (build) => ({
    professionalClientSummary: build.query({
      query: buildProfessionalClientSummaryRequest,
    }),
  }),
  overrideExisting: false,
});

export const {
  useProfessionalClientSummaryQuery,
} = clientSummaryApi;
